import { render, staticRenderFns } from "./MeasurementsBase.vue?vue&type=template&id=09bd2968"
import script from "./MeasurementsBase.vue?vue&type=script&lang=js"
export * from "./MeasurementsBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports